import React from 'react';
import styled from 'styled-components';
import { createPortal } from 'react-dom';
import { colors } from '../../utils/utils';
import CrossIcon from '../common/icons/CrossIcon';

const getModalNode = (): Element => {
    const modalRoot = document.getElementById('modal-root');
    return modalRoot ?? document.body;
};

const ModalOverlay = styled.div<{ $overlayColor: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    width: 100vw;
    height: 100vh;
    background-color: ${props => props.$overlayColor};
`;

const ModalWindow = styled.div<{ $borderRadius?: string }>`
    width: 100%;
    max-width: 300px;
    background-color: white;
    border-radius: ${props => props.$borderRadius || '4px'};
    box-shadow: 0 2px 11px 0 rgb(158, 158, 158);
    padding: 16px;
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
`;

const ModalTitle = styled.div`
    font-weight: 600;
`;

const ModalClose = styled.div`
    margin-left: 16px;
    cursor: pointer;

    &:hover {
        svg {
            fill: ${colors.gray.jumbo};
        }
    }
`;

const ModalBody = styled.div``;

interface ModalProps {
    title?: React.ReactNode;
    children?: React.ReactNode;
    onClose?: (() => void) | undefined;
    borderRadius?: string;
    overlayColor?: string;
}

export default function Modal({ title, children, onClose, borderRadius = '4px', overlayColor = 'rgba(255, 255, 255, 0.75)' }: ModalProps) {
    const modal = (
        <ModalOverlay $overlayColor={overlayColor}>
            <ModalWindow $borderRadius={borderRadius}>
                <ModalHeader>
                    {!!title && <ModalTitle>{title}</ModalTitle>}
                    {!!onClose && (
                        <ModalClose onClick={() => onClose()}>
                            <CrossIcon size={22} />
                        </ModalClose>
                    )}
                </ModalHeader>
                <ModalBody>{children}</ModalBody>
            </ModalWindow>
        </ModalOverlay>
    );

    return createPortal(modal, getModalNode());
}

Modal.defaultProps = {
    onClose: undefined
};

export { ModalButton } from './ModalButton';
